var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackToTopIcon = function SvgBackToTopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22855 0.935338C7.62853 0.450385 8.37147 0.450385 8.77145 0.935338L15.3107 8.86372C15.8486 9.51595 15.3847 10.5 14.5392 10.5H1.46079C0.615317 10.5 0.151372 9.51596 0.68933 8.86372L7.22855 0.935338Z",
    fill: "#1A1A1B"
  })));
};

export { SvgBackToTopIcon as ReactComponent };
export default __webpack_public_path__ + "35b9b8a90b4a4ef7e925ff9efc73e924.svg";